
import { BiltyFormat3 } from "BiltyFomates";
import { getDriverReportApi, getSupplerReportApi } from "_services";
import { CommonModal, CustomSelect } from "components";

import { API, AppConfig } from "lib";
import React, { useEffect, useState } from "react";
import moment from "moment";
import StorageService from "utils/StorageServices/StorageServices";
import { Images } from "constants";
import { StorageServices } from "utils";
import { getFuelReport, getVoucherReport } from "_services/accountingServices/accountingServices";


const FuelReport = (props) => {
    const { voucherId,isOpen } = props;
    const [loading, setLoading] = useState(false);
    const [loadingBilty, setLoadingBilty] = useState(false)
    let isToken = localStorage.getItem("token");
    const [buityFormatePreview, setBuityFormatePreview] = useState('')
    const [isLoaddingPrint, setIsLoaddingPrint] = useState(false)
    const companyId = StorageServices.getCompanyId()

    useEffect(() => {
        if (isOpen) {
            getDriverTripapi()
        }
    }, [isOpen])

    const getDriverTripapi = async () => {

        setLoadingBilty(true)
        try {

            const res = await getFuelReport({
                fuelStatement_id: isOpen,
                is_web: false
            });

            setBuityFormatePreview(res)

            if (res) {
                setLoadingBilty(false)
            }

        } catch (error) {
        }
    };

    const handlePrintDownload = async (voucherId) => {
        try {
            setLoadingBilty(voucherId);

            // const res = await getVoucherReport({
            //     company_id: StorageService?.getCompanyId(),
            //     voucher_id: voucherId
            // });

            let html = buityFormatePreview;

            // Replace title for custom PDF file name
            html = html.replace(
                /<title>.*<\/title>/,
                `<title>Bilty-${voucherId}</title>`
            );

            // Add print styles for single page A5 landscape
            const printStyles = `
            <style>
                @page {
                    size: A5 landscape;
                    margin: 0;
                }
                
                @media print {
                    * {
                        page-break-before: avoid !important;
                        page-break-after: avoid !important;
                        page-break-inside: avoid !important;
                    }
                    
                    html, body {
                        margin: 0 !important;
                        padding: 0 !important;
                        width: 210mm !important;
                        height: 148mm !important;
                        overflow: hidden !important;
                    }
                    
                    body {
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                        padding: 10mm;
                        box-sizing: border-box;
                    }
                    
                    /* Prevent page breaks */
                    table, div, section, article {
                        page-break-inside: avoid !important;
                    }
                }
            </style>
        `;

            // Insert styles before closing </head> tag or at the beginning
            if (html.includes('</head>')) {
                html = html.replace('</head>', `${printStyles}</head>`);
            } else {
                html = printStyles + html;
            }

            const iframe = document.createElement("iframe");
            iframe.style.position = "absolute";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.style.border = "0";
            iframe.style.visibility = "hidden";

            document.body.appendChild(iframe);

            const doc = iframe.contentWindow.document;
            doc.open();
            doc.write(html);
            doc.close();

            setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();

                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 2000);
            }, 500);

            setLoadingBilty(false);
        } catch (err) {
            console.error("Print error:", err);
            setLoadingBilty(false);
        }
    };

    const handleDownload = async () => {
        try {
            const payload = {
                fuelStatement_id: isOpen,
                is_web: true

            }
            setIsLoaddingPrint(true)
            const response = await fetch(`${AppConfig.api_baseurl}${API.GET_FUEL_REPORT}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${moment(new Date()).format("D MMM YYYY")}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setIsLoaddingPrint(false)
        } catch (error) {
            setIsLoaddingPrint(false)
        }
    }

    const formatePrpsTrip = {
        buityFormatePreview: buityFormatePreview
    };



    const propsBuiltyPrint = {
        ...props,
        onPrint: handleDownload,
        onSubmit: handlePrintDownload,
        isLoadding: isLoaddingPrint,
        disabled: isLoaddingPrint,
        isLoaddingPrint: isLoaddingPrint,
        // hide:false
        modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
        footerPart: true,
        submitTitle: "Print",
        therdSubmitTitle: "Download",
    };



    return (
        <>
            <CommonModal {...propsBuiltyPrint}>
                <div className="bltyPrint_body" style={{ display: "block" }}>
                    <div className="bltyPrt_viewPage_bx" id="print-area">

                        {!loadingBilty ? <BiltyFormat3 {...formatePrpsTrip} /> : <div colSpan="100%" style={{ textAlign: "center", margin: "0 22rem", display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
                            <img className="_loadWidth" style={{ width: "150px", color: "f2f2f2" }} src={Images.LOADINGTRUCK} alt="" />
                        </div>}
                    </div>
                </div>
            </CommonModal>


        </>
    );
};

export default FuelReport;
